import { hasIn, isString } from "lodash-es";
import BaseListener from "./baseListener";
import { TrackEvent } from "./baseListener";
import queryString from 'query-string';

//需要记录返回结果的接口
const logResApiList = [
  'wh.inboundtrade.order.submission.process.default',
  'wh.inboundtrade.order.submission.process.list',
];

function convertQueryParamsToJson(data: Record<string, any>): any {
  const result: any = {};

  for (const key of Object.keys(data)) {
    const value = data[key];
    const path = key.split(/[\[\]]/g).filter(p => p !== '');

    let current = result;
    for (let i = 0; i < path.length; i++) {
      const part = path[i];
      const isArrayIndex = /^\d+$/.test(part);
      const isLast = i === path.length - 1;

      if (isLast) {
        // Handle last part (value assignment)
        if (isArrayIndex) {
          const index = parseInt(part, 10);
          current[index] = value;
        } else {
          current[part] = value;
        }
      } else {
        // Handle path traversal
        const nextPart = path[i + 1];
        const nextIsArrayIndex = /^\d+$/.test(nextPart);

        if (isArrayIndex) {
          const index = parseInt(part, 10);
          if (!current[index]) {
            current[index] = nextIsArrayIndex ? [] : {};
          }
          current = current[index];
        } else {
          if (!current[part]) {
            current[part] = nextIsArrayIndex ? [] : {};
          }
          current = current[part];
        }
      }
    }
  }
  return result;
}
class ApiRequestListener extends BaseListener {
  private observer: any = null;
  private perforObserver: any = null;
  private trackerBaseData: any = null;
  constructor() {
    super();
    this.createObserver();
  }
  private createObserver() {
    // 创建一个 PerformanceObserver 实例
    this.perforObserver = new PerformanceObserver(list => {
      list.getEntriesByName('apiResponse').forEach((entry: any) => {
        this.config.onEmit({
          nodeType: 'api',
          ...entry?.detail,
          timestamp: Date.now(),
        });
      });
    });
    //创建一个 MutationObserver 实例
    this.observer = new MutationObserver((mutations:any) => {
      mutations.forEach((mutation: any) => {
        // 只处理当前容器内的变化
        if (!mutation.target.isConnected) return;
        //监听报错信息弹窗及保存报错信息
        (mutation.target as HTMLElement).querySelectorAll('.winitd-modal-confirm-error').forEach((el: Element) => {
          if (!(el as HTMLElement).dataset?.trackerBound) {
            (el as HTMLElement).dataset.trackerBound = 'true';
            let errorTitle = (el.getElementsByClassName('winitd-modal-confirm-title'))[0]?.textContent;
            let errorMsg = (el.getElementsByClassName('winitd-modal-confirm-content'))[0]?.textContent;
            this.config.onEmit({
              nodeType: 'errorModal',
              errorMsg: errorMsg||errorTitle||'',
              success: false,
              timestamp: Date.now(),
            });
          }
        });
      });
    });
  }
  static measure(res: any) {
    let errorMsg = '';
    let errorCode = res?.data?.errorCode;
    if (res?.code == "ERR_NETWORK") { //网络错误
      errorMsg = res?.message;
      errorCode = res?.code;
    }
    else if (res?.status !== 200){//请求失败 @TODO 请求失败返回的数据格式
      errorMsg = isString(res)
        ? res
        : isString(res?.response?.data)
          ? res?.response?.data
          : '';
    }
    else if (res?.data?.status !== 1) {
      errorMsg = res?.data?.info || errorCode;
    }//接口报错信息，没有统一规范，通过报错弹窗监听(errorModal)做兜底
    else if (res?.data?.data?.failCount ||
      res?.data?.data?.errorCount ||
      res?.data?.data?.failedCount ||
      res?.data?.data?.failNum
    ) {
      errorMsg = res?.data?.data?.message || res?.data?.data?.errorMessages || res?.data?.data?.errorMsg;
    }

    //测试环境类似接口:/App/ajaxProcess?api=winit.item.config.queryConfigListByPk,记接口名称
    let api = res?.config?.url;
    if (api?.split?.('api=')?.[1]) {
      api = api.split('api=')?.[1];
    }
    let formData:any = convertQueryParamsToJson(queryString.parse(res?.config?._params));
    /** 入参JSON.stringify后，经过PHP请求的valueNullToEmpty将null会替换成"",正确应是/"/"
     * 轨迹接口再次转为json对象时报错,这里转回json对象**/
    let formParams;
    try {
      formParams = JSON.parse(formData?.form);
    } catch (error) {
      formParams = formData?.form;
    }
    if(formParams) formData.form = formParams;

    let url = formData?.api || api;
    let ext:any = {};
    if (logResApiList.includes(url)) {
      ext.responseData = res?.data?.data;
    }
    let success = true;
    if (hasIn(res?.data, 'status')) {
      success = res?.data?.status === 1 && !errorMsg;
    } else {
      success = errorMsg ? false : true;
    }
    performance.measure('apiResponse', {
      start: 'apiStart',
      end: 'apiEnd',
      detail: {
        href: res?.config?._href,
        url,
        httpStatus: res?.status,
        success: success,
        errorMsg,
        errorCode,
        formData,
        ext,
        duration: res?.config?._startTime ? (Date.now() - res?.config?._startTime) : 0,
      },
    });
  }
  start(onEmit: (event: TrackEvent) => void, container: HTMLElement, trackerBaseData?: any) {
    this.trackerBaseData = trackerBaseData;
    this.config = {
      onEmit: onEmit,
      container: container,
    };

    this.perforObserver.observe({ entryTypes: ['measure']});
    this.observer.observe(this.config.container, {
      childList: true,
      subtree: true
    });
  }

  stop() {
    if (this.perforObserver) {
      this.perforObserver.disconnect();
      this.perforObserver = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

export default ApiRequestListener;
